import * as React from 'react';
import { Box } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';
import { getTimeUnitsToSeconds } from 'lib/timeHelpers';
import { AudienceEditTimeForm, AudienceEditTimeFormData } from '../forms/AudienceEditTimeForm';

type IProps = {
    onClose: () => void;
    onSubmit: (time: number) => void;
    initialData?: Partial<AudienceEditTimeFormData>;
};

const AudienceEditTimeModalContent: React.FC<IProps> = ({ onClose, onSubmit, initialData }: IProps) => {
    const handleSubmit = React.useCallback(
        ({ value, measure }: AudienceEditTimeFormData) => {
            onSubmit(getTimeUnitsToSeconds(Number(value), measure));
        },
        [onSubmit]
    );

    return (
        <Box width="100%" maxWidth={1600}>
            <AudienceEditTimeForm onSubmit={handleSubmit} onClose={onClose} initialData={initialData} />
        </Box>
    );
};

export function AudienceEditTimeModal({ open, ...props }: IProps & { open: boolean }) {
    return (
        <MuiModal open={open}>
            <AudienceEditTimeModalContent {...props} />
        </MuiModal>
    );
}
